import React from 'react';
import '../App.css';
import Background from './Background';









const Position = () => {
  return (
    <Background>
   
    <div className='h-full w-full text-black sm:flex sm:justify-around about py-12 mt-8 overflow-x-hidden' id='about'>
      <div className='flex flex-col justify-around'>
        <div className='sm:px-16 px-2'>
          <h2 className='text-4xl sm:text-5xl text-center font-extrabold mt-2 pt-4 pb-4'>Positions of Responsibility</h2>
          <p className='mt-3 mb-6 text-[17px] max-w-3xl leading-[30px]'>
            As the <b>PR Team Lead for the IOTA Club</b> from <b>August 2022 to August 2023</b>, I successfully secured sponsors for our annual festival, Abhisarga 🎉. Additionally, I organized and conducted numerous events in collaboration with various companies and startups 🤝, enhancing the club's visibility and engagement 📈.
            <br/>
            <br/>
            As a <b>Class Representative</b> on the <b>Student Academic Council</b> since August 2023, I represent my peers' academic interests 📚, facilitate communication between students and faculty 🗣️, and advocate for student needs to enhance our educational experience 📈.
            <br/>
            <br/>
            As a <b>Core Member</b> of the <b> Connexion Club's Data Science team</b> from September 2022 to August 2023, I led data science projects and developed a structured learning roadmap for junior members 📊. I also organized <b>workshops</b> to motivate and encourage juniors to explore the field of data science, fostering a supportive and engaging learning environment 🧑‍🏫📚.
            <br/>
            <br/>
            As a member of the <b>Marketing Team for the Abhisarga Festival 2024</b>, I contributed to promoting and publicizing the event 🎤📢. I implemented strategies to enhance audience <b>engagement and attract</b> participants through social media campaigns and outreach efforts 📱💬.

          </p>
         
          
        </div>
        
      </div>
      
    </div>
    
    </Background>
  )
}

export default Position;
